import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export default function useLogicalProfiles(enabled = true) {
  const { queryFn, queryKey } = queryKeys.users.fetchLogicalProfiles();
  return useQuery({
    enabled,
    queryFn,
    queryKey,
  });
}
